export default __webpack_public_path__ + "static/media/theYeyakVoucherMainLogo.7c6112be.png";